import * as yup from "yup"
import { adonisToYup } from "base/schemaConverter/adonisToYup"
import PessoaService from "business/cadastro/pessoa/pessoa/pessoaService"
import server from "infra/server"

export default class UsuarioServiceCover extends PessoaService {

    title = "Perfil do usuário"
    pluralTitle = "Perfis de usuários"
    url = '/cadastro/pessoa/usuariocover'
    frontUrl = '/cadastro/pessoa/usuariocover'
    frontUrlList = '/cadastro/pessoa/usuariocoverlist'
    primaryKey = 'codigo_usu'
    ignoredsSchemaConvertions = []
    count = 1

    async getSchema() {
        this.requiredFields = []
        return server().get(`${this.url}/schemacover`).then((data) => {

            data.data.ignoreds = this.ignoredsSchemaConvertions
            const schema = adonisToYup(data.data, { onRulesScan: (rule, field, value) => this.onRulesScan(rule, field, value) })
            return yup.object(schema)

        })
    }

}
